import { useCallback, useEffect, useState } from "react";
import NotificacaoService from "../../services/resource/notificacaoService";

const service = new NotificacaoService();

const INTERVALO_POLLING_MS = 30000;

/**
 * Contador de não lidas para o sino do navbar — nunca carrega a lista inteira, só a contagem.
 * Atualizado por polling simples (o projeto ainda não tem WebSocket/SSE); trocar por push em
 * tempo real no futuro só exige substituir o `setInterval` por uma assinatura de evento aqui.
 *
 * `ativo=false` (usuário sem acesso ao MyDash Solicitações) desliga completamente a busca inicial
 * e o polling — a API de notificações é protegida no backend (APP_MYDASH_SOLICITACOES) e não deve
 * ser chamada por quem não tem essa permissão.
 */
export function useContadorNaoLidas(ativo = true) {
    const [quantidade, setQuantidade] = useState(0);

    const buscar = useCallback(() => {
        if (!ativo) return;
        service.contarNaoLidas()
            .then(res => setQuantidade(res.data))
            .catch(() => {});
    }, [ativo]);

    useEffect(() => {
        buscar();
    }, [buscar]);

    useEffect(() => {
        if (!ativo) return;
        const interval = setInterval(buscar, INTERVALO_POLLING_MS);
        return () => clearInterval(interval);
    }, [ativo, buscar]);

    return { quantidade, recarregarContador: buscar };
}

/** Lista de notificações (dropdown do sino com `{ limite: 10 }`, ou a página "Todas" com `{ lida }`). */
export function useNotificacoes(filtros = {}, ativo = true) {
    const [notificacoes, setNotificacoes] = useState([]);
    const [loading, setLoading] = useState(true);
    const chaveFiltros = JSON.stringify(filtros);

    const carregar = useCallback(() => {
        if (!ativo) return;
        setLoading(true);
        service.listarMinhas(JSON.parse(chaveFiltros))
            .then(res => setNotificacoes(res.data))
            .catch(() => {})
            .finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chaveFiltros, ativo]);

    useEffect(() => {
        carregar();
    }, [carregar]);

    async function marcarComoLida(id) {
        await service.marcarComoLida(id);
        setNotificacoes(prev => prev.map(n => n.id === id ? { ...n, lida: true } : n));
    }

    async function marcarTodasComoLidas() {
        await service.marcarTodasComoLidas();
        setNotificacoes(prev => prev.map(n => ({ ...n, lida: true })));
    }

    return { notificacoes, loading, recarregar: carregar, marcarComoLida, marcarTodasComoLidas };
}
